import React from 'react';
import { FEATURED_BADGE } from '../../../common/constants/data-hooks';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { st, classes } from './featured-badge.st.css';
import { getMarkedCommentIcon } from '../../../common/utils/get-marked-comment-icon';
export const FeaturedBadge = ({ customBadgeLabel, customBadgeIcon }) => {
    const t = useTranslate();
    const Icon = getMarkedCommentIcon(customBadgeIcon);
    return (React.createElement("div", { className: st(classes.root), "data-hook": FEATURED_BADGE },
        Icon && React.createElement(Icon, null),
        customBadgeLabel || t('featured-badge.featured')));
};
//# sourceMappingURL=featured-badge.js.map